import React, { useState } from "react";
import {
  TableCell,
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Button,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import WarningIcon from "@material-ui/icons/Warning";
import { ChevronRight } from "@material-ui/icons";
import axios from "axios";
import moment from "moment";
import { useDispatch } from "react-redux";
import { appUrl } from "../../../../../../utils/config";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../containers/actions/types";
import {
  dateFormated,
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";
import CustomDatePickerMui from "../../models/inputs/DateInput";
import BackDropLoading from "../../models/BackDrop";
import StyledDialog from "../../updateGrRecord/Dialog";
import StyledButton from "../../models/Button";

const fetchReasonCodes = async () => {
  try {
    const requestObject = {
      searchField: "all",
      searchValue: "",
      reasonCodeGroupType: "all",
      reasonCodeType: "all",
      status: "all",
      collaboratorTypeID: "all",
    };
    const response = await axios.post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodesDirect`,
      requestObject
    );
    return response.data.status
      ? response.data?.data?.reasonCodeList || []
      : [];
  } catch (err) {
    console.error("Error fetching reason codes:", err);
    return [];
  }
};

const EditSAPPOColumns = (props) => {
  const { row, handleRefresh, featuresAccess, showPencilIcon } = props;
  const dispatch = useDispatch();

  const [qtyDialogOpen, setQtyDialogOpen] = useState(false);
  const [dateDialogOpen, setDateDialogOpen] = useState(false);

  const [reasonCodes, setReasonCodes] = useState([]);
  const [reasonCodesLoading, setReasonCodesLoading] = useState(false);
  const [reasonCodesFetched, setReasonCodesFetched] = useState(false);

  const [sapQty, setSapQty] = useState("");
  const [sapDate, setSapDate] = useState("");
  const [qtyTouched, setQtyTouched] = useState(false);
  const [dateTouched, setDateTouched] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const [saveFailed, setSaveFailed] = useState(false);
  const [savedSuccessfully, setSavedSuccessfully] = useState(false);

  const canEdit =
    localStorage.collabType !== "CMO" && showPencilIcon 
    // &&    featuresAccess?.editSponsorProposedValues;

  const poNumber = row?.scheduleLineDetails?.scheduleAgreementNumber;
  const originalTargetQuantity = row?.scheduleLineDetails?.targetQuantity;
  const originalStatisticalDate = row?.scheduleLineDetails?.statisticalDate;

  const isFutureDate = (date) => {
    if (!date) return false;
    const selected = moment(date).startOf("day");
    const today = moment().startOf("day");
    return selected.isAfter(today);
  };

  const isSameCalendarDate = (date1, date2) => {
    if (!date1 || !date2) return false;
    return moment(date1).isSame(moment(date2), "day");
  };

  const dateValidationMessage = (() => {
    if (!sapDate) return "Please select a statistical date.";
    if (!isFutureDate(sapDate)) return "Statistical date must be a future date.";
    if (isSameCalendarDate(sapDate, originalStatisticalDate))
      return "Statistical date must be different from the current value.";
    return "";
  })();

  const qtyValidationMessage = (() => {
    if (sapQty === "" || sapQty === null || sapQty === undefined)
      return "Please enter SAP PO Qty.";
    if (Number(sapQty) === Number(originalTargetQuantity))
      return "SAP PO Qty must be different from the current value.";
    return "";
  })();

  const loadReasonCodes = async () => {
    if (reasonCodesFetched) return;
    setReasonCodesLoading(true);
    const codes = await fetchReasonCodes();
    setReasonCodes(codes);
    setReasonCodesFetched(true);
    setReasonCodesLoading(false);
  };

  const resetForm = () => {
    setSelectedReason("");
    setComment("");
    setError(false);
  };

  const openQtyDialog = () => {
    setSapQty(row?.scheduleLineDetails?.targetQuantity ?? "");
    setQtyTouched(false);
    resetForm();
    setQtyDialogOpen(true);
    loadReasonCodes();
  };

  const openDateDialog = () => {
    setSapDate(row?.scheduleLineDetails?.statisticalDate ?? "");
    setDateTouched(false);
    resetForm();
    setDateDialogOpen(true);
    loadReasonCodes();
  };

  const handleCloseDialogs = () => {
    setQtyDialogOpen(false);
    setDateDialogOpen(false);
    resetForm();
  };

  const handleCloseSuccess = () => {
    setSavedSuccessfully(false);
    if (typeof handleRefresh === "function") handleRefresh();
  };

  const saveRequest = (payload) => {
    
    dispatch({ type: OPEN_BACKDROP });
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updatePODetailsNew`,
        payload
      )
      .then((res) => {
        dispatch({ type: DESTROY_BACKDROP });
        if (res.data.status) {
          handleCloseDialogs();
          setSavedSuccessfully(true);
        } else {
          setSaveFailed(true);
        }
      })
      .catch(() => {
        dispatch({ type: DESTROY_BACKDROP });
        setSaveFailed(true);
      });
  };

  const buildBasePayload = () => ({
    vendorMosymphonyID: row?.scheduleLineDetails?.vendorMosymphonyID,
    scheduleAgreementStatusID: row?.scheduleLineDetails?.scheduleLineStatusID,
    scheduleAgreementStatusText: row?.scheduleLineDetails?.scheduleLineStatusText,
    schrockenSAID: row?.scheduleLineDetails?.schrockenSAID,
    scheduleAgreementNumber: row?.scheduleLineDetails?.scheduleAgreementNumber,
    vendorName: row?.scheduleLineDetails?.vendorName,
    sponsorName: row?.scheduleLineDetails?.sponsorName,
    productsList: row?.scheduleLineDetails
      ? [
          {
            fgMaterialCode: row?.scheduleLineDetails?.fgMaterialCode,
            fgMaterialName: row?.scheduleLineDetails?.fgMaterialName,
          },
        ]
      : [],
    poApprovedFlag: [21, 22, 23].includes(
      row?.scheduleLineDetails?.scheduleLineStatusID
    )
      ? false
      : true,
    poLineEditFlag: true,
    acceptOfferFlag: false,
    rejectOfferFlag: false,
    approveFlag: false,
    shareWithCMOFlag: false,
    confirmedFlag: false,
  });

  const handleSaveQty = () => {
    if (qtyValidationMessage) return;
    if (!selectedReason && !comment.trim()) {
      setError(true);
      return;
    }
    setError(false);
    saveRequest({
      ...buildBasePayload(),
      updateSAPPOQty: true,
      updateStatisticalDate: false,
      SLDetails: {
        ...row?.scheduleLineDetails,
        targetQuantity: sapQty,
        statisticalDate: originalStatisticalDate,
        reasonCode: selectedReason || null,
        comments: comment,
        changeInQty: false,
        changeInDate: false,
        markedForDelete: false,
      },
    });
  };

  const handleSaveDate = () => {
    if (dateValidationMessage) return;
    if (!selectedReason && !comment.trim()) {
      setError(true);
      return;
    }
    setError(false);
    saveRequest({
      ...buildBasePayload(),
      updateSAPPOQty: false,
      updateStatisticalDate: true,
      SLDetails: {
        ...row?.scheduleLineDetails,
        targetQuantity: originalTargetQuantity,
        statisticalDate: sapDate,
        reasonCode: selectedReason || null,
        comments: comment,
        changeInQty: false,
        changeInDate: false,
        markedForDelete: false,
      },
    });
  };

  const qtySaveDisabled =
    !!qtyValidationMessage || !(selectedReason || comment.trim());
  const dateSaveDisabled =
    !!dateValidationMessage || !(selectedReason || comment.trim());

  const renderReasonCodeAndComment = () => (
    <React.Fragment>
      <Grid container spacing={3} style={{ marginTop: "1rem" }}>
        <Grid item xs={12}>
          <Typography variant="subtitle2" style={{ marginBottom: 10 }}>
            Reason Code / Description
          </Typography>
          <TextField
            select
            fullWidth
            value={selectedReason}
            onChange={(e) => {
              setError(false);
              setSelectedReason(e.target.value);
            }}
            variant="outlined"
            size="small"
            displayEmpty
          >
            <MenuItem value="">
              <em>Select from list</em>
            </MenuItem>
            {reasonCodesLoading ? (
              <MenuItem value="loading" disabled>
                <em>Loading...</em>
              </MenuItem>
            ) : (
              reasonCodes.map((rc) => (
                <MenuItem key={rc.reasonCode} value={rc.reasonCode}>
                  {rc.reasonCode} -{" "}
                  {rc.description || rc.reasonDescription || ""}
                </MenuItem>
              ))
            )}
          </TextField>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: "0.5rem" }}>
        <Grid item xs={12}>
          <Typography variant="subtitle2" style={{ marginBottom: 10 }}>
            Comment
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={3}
            value={comment}
            onChange={(e) => {
              setError(false);
              if (e.target.value.length < 256) setComment(e.target.value);
            }}
            variant="outlined"
            size="small"
            error={error}
            placeholder="Enter text here"
          />
          <Typography variant="caption" style={{ color: error ? "red" : undefined }}>
            Note - If reason code is not entered, comment field is mandatory.
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <TableCell align="right" style={{ whiteSpace: "nowrap", padding: "10px" }}>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            justifyContent: "flex-end",
          }}
        >
          {presentFormatedData(row?.scheduleLineDetails?.targetQuantity, "")}
          {canEdit && featuresAccess?.editSAPPOQty && (
            <span title="Edit SAP PO Qty">
              <EditIcon
                fontSize="large"
                style={{ color: "#ec6535", cursor: "pointer" }}
                onClick={openQtyDialog}
              />
            </span>
          )}
        </Box>
      </TableCell>

      <TableCell align="left" style={{ whiteSpace: "nowrap", padding: "10px" }}>
        <Box style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {dateFormated(
            row?.scheduleLineDetails?.statisticalDate,
            "DD-MMM-YYYY",
            ""
          )}
          {canEdit && featuresAccess?.editStatDate && (
            <span title="Edit Statistical Date">
              <EditIcon
                fontSize="large"
                style={{ color: "#ec6535", cursor: "pointer" }}
                onClick={openDateDialog}
              />
            </span>
          )}
        </Box>
      </TableCell>

      <Dialog open={qtyDialogOpen} maxWidth="sm" fullWidth>
        <BackDropLoading />
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={handleCloseDialogs}
            >
              Cancel <CloseIcon style={{ color: "#FF0000" }} fontSize="large" />
            </Typography>
          </Grid>
          <Typography
            style={{
              fontWeight: 500,
              textAlign: "center",
              fontSize: "1.5rem",
              margin: "1rem",
            }}
          >
            Edit SAP PO Qty for PO {poNumber}
          </Typography>
          <Grid container spacing={3} style={{ marginTop: "1rem" }}>
            <Grid item xs={6}>
              <Typography variant="subtitle2" style={{ marginBottom: 10 }}>
                SAP PO Qty.
              </Typography>
              <TextField
                type="number"
                fullWidth
                value={sapQty}
                onChange={(e) => {
                  const value = parseFloat(e.target.value);
                  if (value > 0 || e.target.value === "") {
                    setSapQty(e.target.value);
                  }
                  setQtyTouched(true);
                }}
                onKeyDown={(e) => {
                  if (["-", "+", "e", "E"].includes(e.key)) e.preventDefault();
                }}
                variant="outlined"
                size="small"
                inputProps={{ min: 1 }}
              />
              {qtyTouched && qtyValidationMessage && (
                <Typography variant="caption" style={{ color: "red" }}>
                  {qtyValidationMessage}
                </Typography>
              )}
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle2" style={{ marginBottom: 10 }}>
                UOM
              </Typography>
              <Typography>
                {presentFormatedData(row?.scheduleLineDetails?.targetQuantityUOM)}
              </Typography>
            </Grid>
          </Grid>
          {renderReasonCodeAndComment()}
        </DialogContent>
        <DialogActions style={{ padding: 16, justifyContent: "center" }}>
          <Button
            variant="contained"
            style={{
              backgroundColor: qtySaveDisabled ? undefined : "#ec6535",
              color: qtySaveDisabled ? undefined : "#fff",
              borderRadius: "20px",
              textTransform: "none",
            }}
            endIcon={<ChevronRight />}
            disabled={qtySaveDisabled}
            onClick={handleSaveQty}
          >
            Save changes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dateDialogOpen} maxWidth="sm" fullWidth>
        <BackDropLoading />
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={handleCloseDialogs}
            >
              Cancel <CloseIcon style={{ color: "#FF0000" }} fontSize="large" />
            </Typography>
          </Grid>
          <Typography
            style={{
              fontWeight: 500,
              textAlign: "center",
              fontSize: "1.5rem",
              margin: "1rem",
            }}
          >
            Edit Statistical Date for PO {poNumber}
          </Typography>
          <Grid container spacing={3} style={{ marginTop: "1rem" }}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" style={{ marginBottom: 10 }}>
                Statistical Date
              </Typography>
              <CustomDatePickerMui
                fullWidth
                value={sapDate}
                onChange={(date) => {
                  setSapDate(date ? date.format("YYYY-MM-DD") + "T00:00" : "");
                  setDateTouched(true);
                }}
                shouldDisableDate={(date) => !date || !date.isAfter(moment(), "day")}
              />
              {dateTouched && dateValidationMessage && (
                <Typography variant="caption" style={{ color: "red" }}>
                  {dateValidationMessage}
                </Typography>
              )}
            </Grid>
          </Grid>
          {renderReasonCodeAndComment()}
        </DialogContent>
        <DialogActions style={{ padding: 16, justifyContent: "center" }}>
          <Button
            variant="contained"
            style={{
              backgroundColor: dateSaveDisabled ? undefined : "#ec6535",
              color: dateSaveDisabled ? undefined : "#fff",
              borderRadius: "20px",
              textTransform: "none",
            }}
            endIcon={<ChevronRight />}
            disabled={dateSaveDisabled}
            onClick={handleSaveDate}
          >
            Save changes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={savedSuccessfully} fullWidth>
        <StyledDialog title="Saved successfully" handleClose={handleCloseSuccess} />
      </Dialog>

      <Dialog open={saveFailed} onClose={() => setSaveFailed(false)} fullWidth>
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => setSaveFailed(false)}
            >
              Close <CloseIcon fontSize="large" />
            </Typography>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
              <WarningIcon style={{ fontSize: "5rem", color: "#F00" }} />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "80px",
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "0.5rem",
            }}
          >
            <StyledButton
              style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
              onClick={() => setSaveFailed(false)}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default EditSAPPOColumns;
